import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import NoImg from '../images/no-img.jpg'

import Paper from '@material-ui/core/Paper'
import Skeleton from '@material-ui/lab/Skeleton';

const styles = (theme) => ({
    ...theme.spreadThis,
    profileDetails: {
        height: 180
    }
})

const ProfileSkeleton = (props) => {
    const { classes } = props;
    return (
        <Paper className={classes.paper}>
            <div className={classes.profile}>
                <div className='image-wrapper'>
                    <img src={NoImg} alt='profile' className='profile-image' />
                </div>
                <hr />
                <div className={classes.profileDetails}>
                    <Skeleton animation="wave" height={30} width="40%" style={{ margin: 'auto', marginBottom: 12 }} />
                    <Skeleton animation="wave" height={20} width="90%" style={{ margin: 'auto', marginBottom: 4 }} />
                    <Skeleton animation="wave" height={20} width="90%" style={{ margin: 'auto', marginBottom: 12 }} />
                    <Skeleton animation="wave" height={20} width="45%" style={{ margin: 'auto', marginBottom: 12 }} />
                    <Skeleton animation="wave" height={20} width="45%" style={{ margin: 'auto' }} />
                </div>
            </div>
        </Paper>
    )
}


ProfileSkeleton.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ProfileSkeleton)
